import { APPLICANT_STAGE } from '../../../RentalPortalApplicant'

export const QA_NAME_APPLICANT_BOARD = 'applicantBoard'

export const QA_NAME_APPLICANT_BOARD_CARD = 'applicantBoardCard'

export const QA_NAME_APPLICANT_BOARD_CARD_ACTIONS = 'applicantBoardCardActions'

export const QA_NAME_APPLICANT_BOARD_CARD_SELECT = 'applicantBoardCardSelect'

export const QA_NAME_APPLICANT_BOARD_COLUMN_SELECT =
  'applicantBoardColumnSelect'

export const QA_NAME_APPLICANT_BOARD_MORE = 'applicantBoardMore'

export const QA_NAME_APPLICANT_BOARD_SKELETON_CARD =
  'applicantBoardSkeletonCard'

export const APPLICANT_BOARD_SKELETON_CARDS = ['first', 'second']

export const APPLICANT_BOARD_COLUMN_ORDER = [
  APPLICANT_STAGE.pool,
  APPLICANT_STAGE.screening,
  APPLICANT_STAGE.selected,
  APPLICANT_STAGE.approved,
]

export const APPLICANT_BOARD_COLUMN_CAP = 25
